export const isOfflineFromUrl = () => window.location.search === '?offline=1';
const isOffline = () => {
    return Boolean((window as any).CASETIVITY_OFFLINE_DOC) || isOfflineFromUrl();
};
export default isOffline;
